module.exports = __webpack_public_path__ + "img/1062486460.9df002da.jpg";